{
    "width": 4003,
    "height": 2340,
    "routes": {
        "purple": [
            [
                [0.5, 1835.11],
                [50.0, 1754.84],
                [100.0, 1725.69],
                [150.0, 1695.32],
                [200.0, 1662.87],
                [250.0, 1629.62],
                [282.09, 1607.95],
                [310.38, 1589.14],
                [338.72, 1570.46],
                [367.21, 1552.13],
                [395.57, 1533.52],
                [423.35, 1513.46],
                [451.06, 1493.26],
                [478.82, 1473.18],
                [506.67, 1453.33],
                [534.6, 1433.65],
                [562.59, 1414.11],
                [590.61, 1394.66],
                [618.36, 1374.54],
                [646.19, 1354.63],
                [674.1, 1334.92],
                [701.87, 1314.85],
                [729.79, 1295.16],
                [757.95, 1276.03],
                [786.17, 1257.06],
                [814.2, 1237.63],
                [842.03, 1217.72],
                [869.76, 1197.56],
                [897.37, 1177.11],
                [925.16, 1157.09],
                [952.81, 1136.73],
                [980.82, 1117.25],
                [1009.47, 1099.33],
                [1038.95, 1083.38],
                [1069.71, 1070.54],
                [1102.2, 1061.9],
                [1136.51, 1057.62],
                [1169.13, 1056.24],
                [1194.29, 1056.0]
            ],
            [
                [1889.88, 1536.0],
                [1915.45, 1536.0],
                [1948.67, 1535.04],
                [1983.41, 1530.72],
                [2015.41, 1519.78],
                [2044.93, 1502.86],
                [2073.39, 1483.37],
                [2101.45, 1462.91],
                [2129.56, 1442.58],
                [2157.69, 1422.31],
                [2185.87, 1402.13],
                [2214.04, 1381.96],
                [2242.22, 1361.78],
                [2270.39, 1341.61],
                [2298.57, 1321.43],
                [2326.74, 1301.26],
                [2354.92, 1281.08],
                [2383.09, 1260.91],
                [2411.27, 1240.73],
                [2439.44, 1220.56],
                [2467.62, 1200.38],
                [2495.79, 1180.22],
                [2523.99, 1160.09],
                [2552.29, 1140.21],
                [2580.83, 1120.92],
                [2609.8, 1102.67],
                [2639.24, 1085.55],
                [2669.7, 1070.89],
                [2701.98, 1060.64],
                [2736.49, 1055.76],
                [2769.04, 1053.2],
                [2794.25, 1052.32]
            ],
            [
                [3319.95, 991.76],
                [3342.01, 984.07],
                [3371.2, 974.45],
                [3402.84, 963.77],
                [3434.77, 953.78],
                [3466.05, 942.22],
                [3495.04, 925.15],
                [3521.63, 903.21],
                [3545.94, 878.28],
                [3567.38, 851.42],
                [3586.9, 823.52],
                [3604.79, 794.86],
                [3621.82, 765.85],
                [3638.04, 736.51],
                [3653.15, 706.7],
                [3667.67, 676.65],
                [3681.59, 646.35],
                [3695.19, 615.92],
                [3708.07, 585.19],
                [3720.21, 554.16],
                [3731.1, 522.6],
                [3740.85, 490.58],
                [3750.34, 458.44],
                [3758.7, 425.84],
                [3766.8, 393.13],
                [3774.3, 360.18],
                [3780.82, 326.81],
                [3786.5, 293.1],
                [3799.15, 250.0],
                [3805.46, 200.0],
                [3809.92, 150.0],
                [3812.32, 100.0],
                [3813.64, 50.0],
                [3813.01, 0.5]
            ]
        ],
        "pink": [
            [
                [0.5, 1250.81],
                [50.0, 1231.65],
                [100.0, 1213.96],
                [150.0, 1197.64],
                [200.0, 1183.15],
                [250.0, 1170.82],
                [276.62, 1165.2],
                [311.59, 1159.12],
                [346.75, 1153.52],
                [382.7, 1149.84],
                [419.42, 1148.0],
                [456.17, 1146.74],
                [492.17, 1144.71],
                [527.25, 1143.13],
                [562.04, 1142.27],
                [596.43, 1143.49],
                [631.53, 1145.08],
                [666.53, 1146.59],
                [702.58, 1146.52],
                [736.02, 1145.2],
                [761.89, 1144.32]
            ],
            [
                [617.26, 1536.88],
                [641.66, 1537.88],
                [673.17, 1536.33],
                [705.97, 1531.13],
                [736.03, 1517.23],
                [764.47, 1498.33],
                [792.28, 1477.24],
                [820.46, 1457.07],
                [849.02, 1437.79],
                [877.46, 1418.23],
                [905.73, 1398.27],
                [933.91, 1378.09],
                [962.17, 1358.1],
                [990.5, 1338.27],
                [1018.86, 1318.53],
                [1046.86, 1297.9],
                [1074.9, 1277.38],
                [1103.0, 1257.0],
                [1131.28, 1237.04],
                [1159.71, 1217.49],
                [1188.36, 1198.44],
                [1216.8, 1178.88],
                [1244.98, 1158.7],
                [1273.0, 1138.12],
                [1300.97, 1117.43],
                [1329.65, 1098.43],
                [1359.09, 1081.29],
                [1390.18, 1068.15],
                [1422.89, 1058.89],
                [1457.29, 1054.36],
                [1489.83, 1053.52],
                [1514.61, 1054.8]
            ],
            [
                [2209.32, 1533.2],
                [2234.12, 1534.8],
                [2266.84, 1534.79],
                [2301.39, 1531.04],
                [2333.42, 1520.55],
                [2363.04, 1504.27],
                [2391.66, 1485.54],
                [2420.18, 1466.62],
                [2448.5, 1447.18],
                [2476.65, 1427.35],
                [2504.71, 1407.29],
                [2532.77, 1387.23],
                [2560.83, 1367.17],
                [2588.89, 1347.11],
                [2616.95, 1327.05],
                [2645.01, 1306.99],
                [2673.07, 1286.93],
                [2701.13, 1266.87],
                [2729.19, 1246.81],
                [2757.25, 1226.75],
                [2785.31, 1206.69],
                [2813.37, 1186.63],
                [2841.43, 1166.57],
                [2869.54, 1146.64],
                [2897.79, 1127.03],
                [2926.32, 1108.12],
                [2955.26, 1090.18],
                [2985.23, 1074.74],
                [3016.93, 1063.45],
                [3050.47, 1057.28],
                [3085.05, 1054.72],
                [3117.35, 1055.12],
                [3142.31, 1055.68]
            ],
            [
                [3872.74, 1543.54],
                [3880.0, 1555.65],
                [3915.0, 1567.17],
                [3950.0, 1585.76],
                [3985.0, 1603.42],
                [4002.5, 1612.25]
            ]
        ],
        "orange": [
            [
                [80.68, 909.4],
                [103.8, 919.89],
                [133.77, 934.69],
                [166.03, 951.55],
                [198.32, 968.32],
                [231.1, 983.91],
                [265.24, 996.24],
                [300.96, 1004.73],
                [336.85, 1012.83],
                [372.14, 1022.37],
                [403.62, 1033.52],
                [427.26, 1042.77]
            ],
            [
                [941.29, 1536.69],
                [965.79, 1537.14],
                [997.52, 1534.89],
                [1030.93, 1528.48],
                [1061.68, 1514.88],
                [1090.56, 1496.66],
                [1118.62, 1476.44],
                [1146.71, 1456.29],
                [1174.88, 1436.36],
                [1202.99, 1416.24],
                [1231.04, 1396.01],
                [1259.07, 1375.71],
                [1287.0, 1355.18],
                [1315.29, 1335.54],
                [1343.57, 1315.85],
                [1371.81, 1296.07],
                [1399.94, 1276.03],
                [1428.06, 1255.94],
                [1456.16, 1235.84],
                [1484.27, 1215.73],
                [1512.39, 1195.67],
                [1540.53, 1175.65],
                [1568.68, 1155.65],
                [1596.84, 1135.66],
                [1625.24, 1116.27],
                [1654.13, 1098.06],
                [1683.63, 1081.32],
                [1714.35, 1067.51],
                [1746.91, 1058.8],
                [1781.05, 1055.04],
                [1813.28, 1055.12],
                [1838.29, 1055.68]
            ],
            [
                [2565.28, 1536.88],
                [2589.63, 1537.01],
                [2620.93, 1533.03],
                [2653.29, 1523.43],
                [2683.22, 1507.3],
                [2711.86, 1488.07],
                [2740.09, 1467.87],
                [2768.33, 1447.66],
                [2796.56, 1427.44],
                [2824.78, 1407.22],
                [2853.01, 1386.99],
                [2881.24, 1366.76],
                [2909.46, 1346.54],
                [2937.76, 1326.48],
                [2966.11, 1306.56],
                [2994.59, 1286.94],
                [3022.82, 1266.72],
                [3051.13, 1246.71],
                [3079.17, 1226.03],
                [3107.49, 1206.03],
                [3136.12, 1186.78],
                [3164.66, 1167.3],
                [3193.05, 1147.46],
                [3221.3, 1127.3],
                [3249.83, 1107.81],
                [3279.04, 1089.95],
                [3309.31, 1074.65],
                [3341.41, 1063.78],
                [3375.69, 1058.16],
                [3408.6, 1056.32],
                [3434.09, 1056.0]
            ],
            [
                [3345.08, 1400.77],
                [3375.3, 1404.62],
                [3412.47, 1414.96],
                [3450.91, 1432.63],
                [3485.08, 1452.76],
                [3510.43, 1470.11]
            ],
            [
                [3704.73, 1314.02],
                [3728.17, 1325.12],
                [3759.03, 1339.6],
                [3792.75, 1353.64],
                [3827.27, 1362.22],
                [3850.0, 1369.32],
                [3885.0, 1360.36],
                [3920.0, 1352.43],
                [3955.0, 1341.7],
                [3990.0, 1330.26],
                [4002.5, 1275.75]
            ]
        ],
        "green": [
            [
                [36.53, 2287.92],
                [44.84, 2265.66],
                [55.46, 2236.28],
                [67.86, 2204.88],
                [83.04, 2174.96],
                [104.38, 2148.02],
                [128.4, 2121.76],
                [152.24, 2095.11],
                [174.5, 2067.61],
                [194.86, 2039.32],
                [213.34, 2010.25],
                [230.15, 1980.5],
                [244.86, 1949.87],
                [258.45, 1918.78],
                [272.82, 1888.01],
                [289.21, 1858.08],
                [308.26, 1829.25],
                [328.66, 1800.98],
                [348.26, 1772.38],
                [367.26, 1743.53],
                [385.59, 1714.4],
                [403.91, 1685.27],
                [422.99, 1656.45],
                [440.94, 1630.1],
                [455.66, 1610.5]
            ],
            [
                [282.01, 1485.67],
                [300.5, 1466.3],
                [325.09, 1440.43],
                [352.84, 1412.68],
                [381.53, 1385.97],
                [410.87, 1360.33],
                [441.24, 1337.21],
                [472.43, 1316.06],
                [504.16, 1296.22],
                [536.18, 1277.08],
                [568.63, 1258.97],
                [601.39, 1241.62],
                [634.94, 1226.18],
                [666.36, 1213.3],
                [690.69, 1204.51]
            ],
            [
                [1245.81, 1536.08],
                [1271.0, 1536.22],
                [1303.36, 1535.47],
                [1337.77, 1531.08],
                [1369.92, 1520.14],
                [1399.84, 1503.17],
                [1428.6, 1483.4],
                [1457.07, 1462.93],
                [1485.54, 1442.46],
                [1514.01, 1421.99],
                [1542.48, 1401.52],
                [1570.95, 1381.05],
                [1599.42, 1360.58],
                [1627.89, 1340.11],
                [1656.36, 1319.64],
                [1684.84, 1299.16],
                [1713.31, 1278.69],
                [1741.78, 1258.22],
                [1770.25, 1237.75],
                [1798.72, 1217.28],
                [1827.19, 1196.82],
                [1855.69, 1176.42],
                [1884.24, 1156.14],
                [1912.99, 1136.35],
                [1942.01, 1117.2],
                [1971.5, 1099.19],
                [2001.34, 1082.02],
                [2032.62, 1068.33],
                [2065.93, 1059.54],
                [2101.08, 1055.83],
                [2133.75, 1054.4],
                [2158.59, 1055.12]
            ],
            [
                [2809.56, 1559.68],
                [2834.28, 1558.48],
                [2866.26, 1555.68],
                [2900.37, 1551.04],
                [2933.24, 1543.44],
                [2964.0, 1530.72],
                [2993.27, 1514.4],
                [3021.45, 1495.46],
                [3049.32, 1475.78],
                [3077.34, 1456.45],
                [3105.53, 1437.52],
                [3133.56, 1418.22],
                [3161.44, 1398.56],
                [3189.26, 1378.74],
                [3217.08, 1358.92],
                [3244.89, 1339.11],
                [3272.71, 1319.29],
                [3300.53, 1299.47],
                [3328.35, 1279.65],
                [3356.16, 1259.84],
                [3383.98, 1240.02],
                [3411.8, 1220.2],
                [3439.71, 1200.61],
                [3467.78, 1181.42],
                [3495.98, 1162.5],
                [3523.79, 1142.69],
                [3551.24, 1121.96],
                [3578.8, 1101.52],
                [3606.52, 1081.48],
                [3634.34, 1061.66],
                [3662.21, 1041.99],
                [3690.23, 1022.65],
                [3718.52, 1003.98],
                [3746.92, 985.56],
                [3770.0, 971.46],
                [3805.0, 949.16],
                [3840.0, 927.13],
                [3875.0, 905.6],
                [3910.0, 884.72],
                [3945.0, 864.1],
                [3980.0, 844.42],
                [4001.5, 886.63]
            ]
        ],
        "blue": [
            [
                [187.99, 0.5],
                [187.06, 50.0],
                [188.47, 100.0],
                [191.06, 150.0],
                [195.69, 200.0],
                [201.67, 250.0],
                [212.05, 289.39],
                [217.4, 323.98],
                [224.25, 357.95],
                [231.87, 391.6],
                [239.93, 425.06],
                [248.3, 458.41],
                [257.51, 491.4],
                [268.28, 523.74],
                [279.91, 555.73],
                [292.27, 587.42],
                [305.26, 618.84],
                [319.54, 649.74],
                [334.24, 680.45],
                [350.04, 710.72],
                [366.08, 740.88],
                [382.85, 770.74],
                [399.95, 800.46],
                [417.49, 830.01],
                [436.58, 858.9],
                [457.14, 887.19],
                [479.06, 914.92],
                [501.97, 941.41],
                [526.48, 964.84],
                [554.73, 982.57],
                [585.01, 997.4],
                [615.64, 1012.32],
                [645.99, 1027.9],
                [676.23, 1043.77],
                [706.42, 1059.75],
                [736.35, 1076.24],
                [766.71, 1091.0],
                [795.64, 1100.92],
                [818.92, 1103.94]
            ],
            [
                [1597.28, 1536.88],
                [1621.63, 1537.01],
                [1652.93, 1533.03],
                [1685.3, 1523.44],
                [1715.23, 1507.33],
                [1743.89, 1488.15],
                [1772.14, 1467.98],
                [1800.42, 1447.88],
                [1828.76, 1427.93],
                [1857.15, 1408.1],
                [1885.62, 1388.46],
                [1914.17, 1369.03],
                [1942.48, 1348.99],
                [1970.6, 1328.52],
                [1998.62, 1307.78],
                [2027.06, 1288.06],
                [2055.45, 1268.23],
                [2083.77, 1248.23],
                [2111.99, 1228.01],
                [2140.22, 1207.78],
                [2168.45, 1187.55],
                [2196.67, 1167.33],
                [2224.94, 1147.21],
                [2253.34, 1127.4],
                [2282.03, 1108.28],
                [2311.16, 1090.25],
                [2341.35, 1074.76],
                [2373.41, 1063.78],
                [2407.69, 1058.16],
                [2440.6, 1056.32],
                [2466.09, 1056.0]
            ],
            [
                [3426.0, 1344.32],
                [3451.67, 1345.2],
                [3485.09, 1347.12],
                [3520.71, 1350.48],
                [3553.44, 1359.1],
                [3580.63, 1376.75],
                [3602.23, 1402.16],
                [3619.64, 1431.65],
                [3634.89, 1462.53],
                [3648.01, 1494.29],
                [3658.84, 1527.0],
                [3667.81, 1560.47],
                [3676.0, 1594.27],
                [3684.0, 1628.15],
                [3692.0, 1662.03],
                [3700.0, 1695.91],
                [3708.32, 1729.66],
                [3717.75, 1762.95],
                [3729.28, 1795.37],
                [3742.68, 1827.01],
                [3757.18, 1858.2],
                [3773.19, 1888.76],
                [3790.8, 1918.65],
                [3809.74, 1948.0],
                [3830.0, 1946.2],
                [3865.0, 2000.6],
                [3900.0, 2042.57],
                [3935.0, 2075.35],
                [3970.0, 2101.61],
                [4001.5, 2120.77]
            ]
        ]
    }
}
